import React, { Component } from "react";
import { config } from "_helpers/config";
import { connect } from "react-redux";
import { docsActions } from "_actions/docs.actions";
import { chatActions } from "_actions/chat.actions";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Tab, Row, Col, NavItem, Nav } from "react-bootstrap";
import { MerchandiseOrder } from "Docs/Forms/MerchandiseOrderForm";
import Payroll from "Docs/Forms/Payroll";
import TimeOffRequest from "Docs/Forms/TimeOffRequest";
import { PaycheckDistribution } from "Docs/Forms/PaycheckDistribution";
import { CandidateInfoPage } from "Docs/Forms/CandidateInfoPage";
import { W4 } from "Docs/Forms/W4";
import { StateTax } from "Docs/Forms/StateTax";
import InterviewForm from "InterviewForm";
import ErrorBoundary from "_components/ErrorBoundary";
import { selectCurrentUserPermissions } from "_helpers/reduxSelector";
import EquipmentResponsibilityForm from "Docs/Forms/EquipmentResponsibilityForm";
import DocStatusTag from "_components/utils/DocStatusTag";
import VerbalWarningAck from "Docs/Forms/VerbalWarningAck/VerbalWarningAck";
import BeneficiaryForm from "Docs/Forms/BeneficiaryForm";
import { formatDate } from "_helpers/helpers";
import WithholdingAllowanceCertificate from "Docs/Forms/WithholdingAllowanceCertificate";
import { toast } from "react-toastify";
import ReactModal from "react-modal";
import moment from "moment";

const DocumentTypes = {
  Onboarding: 1,
  Rehire: 2,
  Other: 3,
  GISS_Onboarding: 4,
  GISS_Rehire: 5,
};

class UserDocsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order_doc: "asc",
      order_at: "asc",
      documents: [],
      view_doc: false,
      adminMode: true,
      tab: "list",
      doc: {
        new: null,
        id: null,
        slug: "merchandise-order-form",
      },
      showDeleteModal: false,
      docToDelete: null,
    };
    // Bindings
    this.sortHandler = this.sortHandler.bind(this);
    this.tabChange = this.tabChange.bind(this);
    this.generateDocList = this.generateDocList.bind(this);
    this.viewDoc = this.viewDoc.bind(this);
    this.viewList = this.viewList.bind(this);
    this._compareFn = this._compareFn.bind(this);
    this.sortHandler = this.sortHandler.bind(this);
    this.handleDeleteDocument = this.handleDeleteDocument.bind(this);
    this.confirmDeleteDocument = this.confirmDeleteDocument.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
  }

  // Helper function to check if a date is within the last week
  isWithinLastWeek(dateString) {
    if (!dateString) return false;
    const docDate = moment(dateString);
    const oneWeekAgo = moment().subtract(1, 'week');
    return docDate.isAfter(oneWeekAgo);
  }

  // Compare function
  _compareFn(a, b, type, by) {
    if (type === "docs_name") {
      if (by === "asc") {
        let name_1 = a.doc_type_name,
          name_2 = b.doc_type_name;
        if (name_1 < name_2) {
          return -1;
        } else if (name_1 > name_2) {
          return 1;
        } else return 0;
      } else {
        let name_1 = a.doc_type_name,
          name_2 = b.doc_type_name;
        if (name_1 < name_2) {
          return 1;
        } else if (name_1 > name_2) {
          return -1;
        } else return 0;
      }
    } else if (type === "updated_at") {
      if (by === "asc") {
        let date_1 = new Date(a.updated_at),
          date_2 = new Date(b.updated_at);
        if (date_1 < date_2) {
          return -1;
        } else if (date_1 > date_2) {
          return 1;
        } else return 0;
      } else {
        let date_1 = new Date(a.updated_at),
          date_2 = new Date(b.updated_at);
        if (date_1 < date_2) {
          return 1;
        } else if (date_1 > date_2) {
          return -1;
        } else return 0;
      }
    } else if (type === "created_at") {
      if (by === "asc") {
        let date_1 = new Date(a.created_at),
          date_2 = new Date(b.created_at);
        if (date_1 < date_2) {
          return -1;
        } else if (date_1 > date_2) {
          return 1;
        } else return 0;
      } else {
        let date_1 = new Date(a.created_at),
          date_2 = new Date(b.created_at);
        if (date_1 < date_2) {
          return 1;
        } else if (date_1 > date_2) {
          return -1;
        } else return 0;
      }
    }
    return 0;
  }
  // Handle sorting in table
  sortHandler(type) {
    let documents = this.state.documents;
    documents.sort();
    switch (type) {
      case "docs_name":
        if (this.state.order_doc === "asc") {
          documents.sort((a, b) => this._compareFn(a, b, "docs_name", "asc"));
          this.setState({ documents, order_doc: "desc" });
        } else {
          documents.sort((a, b) => this._compareFn(a, b, "docs_name", "desc"));
          this.setState({ documents, order_doc: "asc" });
        }
        break;
      case "updated_at":
        if (this.state.order_at === "asc") {
          documents.sort((a, b) => this._compareFn(a, b, "updated_at", "asc"));
          this.setState({ documents, order_at: "desc" });
        } else {
          documents.sort((a, b) => this._compareFn(a, b, "updated_at", "desc"));
          this.setState({ documents, order_at: "asc" });
        }
        break;
      case "created_at":
        if (this.state.created_at === "asc") {
          documents.sort((a, b) => this._compareFn(a, b, "created_at", "asc"));
          this.setState({ documents, created_at: "desc" });
        } else {
          documents.sort((a, b) => this._compareFn(a, b, "created_at", "desc"));
          this.setState({ documents, created_at: "asc" });
        }
        break;
      default:
        return this.state.documents;
    }
  }

  tabChange(tab) {
    this.setState({
      tab,
    });
  }

  viewDoc(doc) {
    this.setState({
      doc: {
        ...this.state.doc,
        id: doc.id,
        slug: doc?.slug,
        docs_type_id: doc?.docs_type_id,
        tor_docs_status: doc?.tor_docs_status,
      },
      view_doc: true,
      tab: "document",
    });
  }

  viewList() {
    this.setState({
      doc: { ...this.state.doc, id: null },
      view_doc: false,
      tab: "list",
    });
  }

  handleDeleteDocument(doc) {
    // Store the document to be deleted in state for the modal
    this.setState({
      docToDelete: doc,
      showDeleteModal: true
    });
  }

  closeDeleteModal() {
    this.setState({
      showDeleteModal: false,
      docToDelete: null
    });
  }

  handleDeleteConfirm() {
    const { docToDelete } = this.state;
    if (docToDelete) {
      this.confirmDeleteDocument(docToDelete);
      this.closeDeleteModal();
    }
  }

  confirmDeleteDocument(doc) {
    this.props.dispatch(docsActions.deleteDocument(doc.id))
      .then(() => {
        // Refresh the documents list after successful deletion
        this.props.dispatch(docsActions.getUserDocs(this.props.userHash))
          .then((res) => {
            this.setState({ documents: this.props.docs.userDocs });
          });
        // Show success toast message
        toast.success('Document deleted successfully', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((error) => {
        console.error('Error deleting document:', error);
        toast.error('Error deleting document. Please try again.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  }

  generateDocList(list, type, other, rehire, giss) {
    // let signature = this.props.chat.settings.signature;
    // let loggedInUser = this.props.user.profile.data.hash;
    let signature;
    this.props.chat?.settings &&
      (signature = this.props.chat.settings.signature);
    let loggedInUser;
    this.props.user?.profile &&
      (loggedInUser = this.props.user.profile.data.hash);
    let selectedUser = (() => this.props.user?.items.data)();
    let empty_list, docs_list;
    let filteredList = list;
    if (type === DocumentTypes.Rehire || type === DocumentTypes.GISS_Rehire) {
      filteredList = list.filter(
        (doc) => doc.docs_categories_id == 2 || doc.docs_categories_id == 5,
      );
    } else if (
      type === DocumentTypes.Onboarding ||
      type === DocumentTypes.GISS_Onboarding
    ) {
      filteredList = list.filter(
        (doc) => doc.docs_categories_id == 1 || doc.docs_categories_id == 4,
      );
    } else {
      filteredList = list.filter((doc) => doc.docs_categories_id == type);
    }

    (filteredList.length === 0 && type === 1) || type === 4
      ? (empty_list = (
          <p className="doc-list-empty">
            <strong>{selectedUser.full_name}</strong> haven't submitted any
            Onboarding Documents
          </p>
        ))
      : type === 3 || type === 6
        ? (empty_list = (
            <p className="doc-list-empty">
              <strong>{selectedUser.full_name}</strong> haven't added any Other
              Documents
            </p>
          ))
        : (empty_list = (
            <p className="doc-list-empty">
              <strong>{selectedUser.full_name}</strong> haven't added any Rehire
              Documents
            </p>
          ));
    docs_list = empty_list;

    filteredList.length > 0 &&
      (docs_list = filteredList.map((doc, index) => {
        let docStatus = "";
        const docStatusColor =
          doc.tor_docs_status === 4 ? "#3f7e39" : "#c9c188";

        switch (doc?.tor_docs_status) {
          case 1:
            docStatus = "Not Approved";
            break;
          case 2:
            docStatus = "Submitted";
            break;
          case 3:
            docStatus = "In review";
            break;
          case 4:
            docStatus = "Approved";
            break;
          case 5:
            docStatus = "Not filled";
            break;
          default:
            docStatus = "Not approved";
            break;
        }

        return (
          <div className="applicant_item list_item">
            <div className="homeEmp_list">
              <div className="basic_info unavailable_employe">
                <div className="item_cell">
                  <img
                    className="doc-list-img"
                    src={`${config.assetUrl}icons/doc-check-circle.svg`}
                    alt=""
                  />
                  <span>
                    {doc.doc_type_name}
                    {!!(doc.docs_type_id === 23) && (
                      <DocStatusTag
                        status={docStatus}
                        bgColor={docStatusColor}
                        fontColor={doc.tor_docs_status === 4 ? "#fff" : ""}
                      />
                    )}
                  </span>
                </div>
                <div className="item_cell">
                  <span>{formatDate(doc.created_at)}</span>
                </div>
                <div className="item_cell">
                  <span>
                    {" "}
                    {doc.docs_categories_id === 3
                      ? doc.docs_type_id === 23 && doc.tor_docs_status === 4
                        ? formatDate(doc.approved_date)
                        : "-"
                      : formatDate(doc.updated_at)}
                  </span>
                </div>
                {
                  <div className="item_cell  doc_download">
                    <span>
                      {doc.docs_type.id !== 29 && (
                        <a
                          href={`${config.apiUrl}/docs/pdf/${doc.slug}?id=${doc.id}&signature=${signature}&uid=${loggedInUser}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={`${config.assetUrl}icons/doc-admin-download.svg`}
                            alt=""
                          />
                        </a>
                      )}
                    </span>
                  </div>
                }
                <div className="item_cell  doc_download">
                  {other ? (
                    <span>
                      <a onClick={() => this.viewDoc(doc)}>
                        <img
                          src={`${config.assetUrl}icons/doc-admin-view.svg`}
                          alt=""
                        />
                      </a>
                    </span>
                  ) : rehire ? (
                    <span>
                      <Link
                        to={`/docs/${this.props.userHash}/${doc.slug}?rehire=true`}
                      >
                        <img
                          src={`${config.assetUrl}icons/doc-admin-view.svg`}
                          alt=""
                        />
                      </Link>
                    </span>
                  ) : (
                    <span>
                      <Link
                        to={`/docs/${this.props.userHash}/${doc.slug}?rehire=false`}
                      >
                        <img
                          src={`${config.assetUrl}icons/doc-admin-view.svg`}
                          alt=""
                        />
                      </Link>
                    </span>
                  )}
                </div>
                {/* Delete Document - Show for docs created more than 1 week ago and user has Manage Docs permission, only in Other Documents tab */}
                {this.props.currentUserPermissions?.includes("Manage Docs") && !this.isWithinLastWeek(doc.created_at) && type === 3 && (
                  <div className="item_cell doc_download">
                    <span className="delete-document">
                      <button
                        className="button plain delete-btn"
                        onClick={() => this.handleDeleteDocument(doc)}
                        title="Delete Document"
                      >
                        <img 
                          style={{ 'vertical-align': 'middle' }}
                          src={`${config.assetUrl}icons/delete-icon-gold.svg`}
                          className="deleteIco"
                          alt="Delete"
                        />
                      </button>
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      }));

    return docs_list;
  }

  componentDidMount() {
    let hash = this.props.userHash;
    this.props.dispatch(chatActions.getConversationSettings());
    this.props.dispatch(docsActions.getUserDocs(hash)).then((res) => {
      this.setState({ documents: this.props.docs.userDocs });
    });
  }
  render() {
    let selectedUser = null;
    this.props.user?.items &&
      (selectedUser = this.props.user.items.data);

    return (
      <div>
        <Tab.Container id="tabs-with-dropdown" defaultActiveKey="first">
          <Row className="clearfix">
            <Col sm={12}>
              <div className="custom-tabs m-0">
                <Nav bsStyle="tabs">
                  <NavItem eventKey="first" className="custom-tab">
                    <i className="fa fa-file"></i>
                    Onboarding Documents
                  </NavItem>
                  <NavItem eventKey="second" className="custom-tab">
                    <i className="fa fa-file-download"></i>
                    Rehire Documents
                  </NavItem>
                  <NavItem eventKey="third" className="custom-tab">
                    <i className="fa fa-file-alt"></i>
                    Other Documents
                  </NavItem>
                  {this?.props?.currentUserPermissions?.includes(
                    "Manage Interview Forms",
                  ) && (
                    <NavItem eventKey="fourth" className="custom-tab">
                      <i className="fa fa-clipboard-list"></i>
                      Interview Forms
                    </NavItem>
                  )}
                </Nav>
              </div>
            </Col>
            <Col sm={12}>
              <div className="custom-tab-content">
                <Tab.Content animation>
                  {/* Onboarding DOCUMENTS */}
                  <Tab.Pane eventKey="first">
                    {/* <!--enable this tab contents corresponding to the tab clicked--> */}
                    <div className="appln_list_header">
                      <div
                        className="list_item_head"
                        onClick={() => this.sortHandler("docs_name")}
                      >
                        Name
                        <span
                          className={`${
                            this.state.order_doc === "asc" ? "asc" : "desc"
                          } sort-arrow`}
                        ></span>
                      </div>
                      <div
                        className="list_item_head appln_date"
                        onClick={() => this.sortHandler("updated_at")}
                      >
                        Date Updated
                        <span
                          className={`${
                            this.state.order_at === "asc" ? "asc" : "desc"
                          } sort-arrow`}
                        ></span>
                      </div>
                      <div
                        className="list_item_head appln_date"
                        onClick={() => this.sortHandler("created_at")}
                      >
                        Date Created
                        <span
                          className={`${
                            this.state.created_at === "asc" ? "asc" : "desc"
                          } sort-arrow`}
                        ></span>
                      </div>
                      <div className="list_item_head"></div>
                      <div className="list_item_head"></div>
                    </div>
                    {selectedUser &&
                      this.generateDocList(
                        this.state.documents,
                        selectedUser.user_type_id === 11 ||
                          selectedUser.user_type_id === 12
                          ? 4
                          : 1,
                        false,
                        false,
                        selectedUser.user_type_id === 11 ||
                          selectedUser.user_type_id === 12,
                      )}
                  </Tab.Pane>

                  {/* Rehire DOCUMENTS */}
                  <Tab.Pane eventKey="second">
                    {/* <!--enable this tab contents corresponding to the tab clicked--> */}
                    <div className="appln_list_header">
                      <div
                        className="list_item_head"
                        onClick={() => this.sortHandler("docs_name")}
                      >
                        Name
                        <span
                          className={`${
                            this.state.order_doc === "asc" ? "asc" : "desc"
                          } sort-arrow`}
                        ></span>
                      </div>
                      <div
                        className="list_item_head appln_date"
                        onClick={() => this.sortHandler("updated_at")}
                      >
                        Date Updated
                        <span
                          className={`${
                            this.state.order_at === "asc" ? "asc" : "desc"
                          } sort-arrow`}
                        ></span>
                      </div>
                      <div
                        className="list_item_head appln_date"
                        onClick={() => this.sortHandler("created_at")}
                      >
                        Date Created
                        <span
                          className={`${
                            this.state.created_at === "asc" ? "asc" : "desc"
                          } sort-arrow`}
                        ></span>
                      </div>
                      <div className="list_item_head"></div>
                      <div className="list_item_head"></div>
                    </div>
                    {selectedUser &&
                      this.generateDocList(
                        this.state.documents,
                        selectedUser.user_type_id === 11 ||
                          selectedUser.user_type_id === 12
                          ? 5
                          : 2,
                        false,
                        true,
                        selectedUser.user_type_id === 11 ||
                          selectedUser.user_type_id === 12,
                      )}
                  </Tab.Pane>

                  {/* Other Documents */}
                  <Tab.Pane eventKey="third">
                    <section className="content onboarding-docs">
                      {/* LIST */}
                      {this.state.tab === "list" && (
                        <section className="list">
                          {/* <!--enable this tab contents corresponding to the tab clicked--> */}
                          <div className="appln_list_header">
                            <div
                              className="list_item_head"
                              onClick={() => this.sortHandler("docs_name")}
                            >
                              Name
                              <span
                                className={`${
                                  this.state.order_doc === "asc"
                                    ? "asc"
                                    : "desc"
                                } sort-arrow`}
                              ></span>
                            </div>
                            <div
                              className="list_item_head appln_date"
                              onClick={() => this.sortHandler("updated_at")}
                            >
                              Date Submitted
                              <span
                                className={`${
                                  this.state.order_at === "asc" ? "asc" : "desc"
                                } sort-arrow`}
                              ></span>
                            </div>
                            <div
                              className="list_item_head appln_date"
                              onClick={() => this.sortHandler("created_at")}
                            >
                              Date Approved
                              <span
                                className={`${
                                  this.state.created_at === "asc"
                                    ? "asc"
                                    : "desc"
                                } sort-arrow`}
                              ></span>
                            </div>
                            <div className="list_item_head"></div>
                            <div className="list_item_head"></div>
                            <div className="list_item_head"></div>
                          </div>
                          {selectedUser &&
                            this.generateDocList(
                              this.state.documents,
                              3,
                              true,
                              false,
                              selectedUser.user_type_id === 11 ||
                                selectedUser.user_type_id === 12,
                            )}
                        </section>
                      )}
                      {/* DOCUMENT */}
                      {this.state.tab === "document" && (
                        <section className="document">
                          <p className="buttonWrapper">
                            <button
                              id="back-button"
                              className="button"
                              onClick={this.viewList}
                            >
                              Back
                            </button>
                          </p>
                          <div className="container doc_info full-width_form">
                            {this.state?.doc?.slug ===
                              "merchandise-order-form" && (
                              <MerchandiseOrder
                                viewList={this.viewList}
                                view_doc={this.state.view_doc}
                                new_doc_id={this.state.doc.id}
                                single_doc={true}
                                tabChange={this.tabChange}
                                slug="merchandise-order-form"
                                adminMode={this.state.adminMode}
                                lastPage={true}
                              />
                            )}
                            {this.state?.doc?.slug === "payroll-deduction" && (
                              <Payroll
                                goBack={() => this.viewList()}
                                isSingleDoc={true}
                                adminMode={this.state.adminMode}
                                docDetails={this.state?.doc}
                              />
                            )}
                            {this.state?.doc?.slug === "time-off-request" && (
                              <TimeOffRequest
                                goBack={() => this.viewList()}
                                isSingleDoc={true}
                                adminMode={this.state.adminMode}
                                docDetails={this.state?.doc}
                                status={this.state?.doc?.tor_docs_status}
                              />
                            )}
                            {this.state?.doc?.slug === "warning-management" && (
                              <VerbalWarningAck
                                goBack={() => this.viewList()}
                                isSingleDoc={true}
                                adminMode={this.state.adminMode}
                                docDetails={this.state?.doc}
                              />
                            )}
                            {this.state?.doc?.slug ===
                              "paycheck-distribution-form" && (
                              <PaycheckDistribution
                                goBack={() => this.viewList()}
                                single_doc={true}
                                adminMode={this.state.adminMode}
                                new_doc_id={this.state.doc.id}
                                slug={this.state.doc.slug}
                                lastPage={true}
                              />
                            )}
                            {this.state?.doc?.slug ===
                              "employee-information-page" && (
                              <CandidateInfoPage
                                goBack={() => this.viewList()}
                                single_doc={true}
                                adminMode={this.state.adminMode}
                                new_doc_id={this.state.doc.id}
                                slug={this.state.doc.slug}
                                lastPage={true}
                              />
                            )}
                            {this.state?.doc?.slug === "beneficiary-form" && (
                              <BeneficiaryForm
                                goBack={() => this.viewList()}
                                single_doc={true}
                                adminMode={this.state.adminMode}
                                new_doc_id={this.state.doc.id}
                                slug={this.state.doc.slug}
                                lastPage={true}
                                doc={this.state.doc}
                                docs={this.props.docs}
                              />
                            )}
                            {this.state?.doc?.slug === "withholding-allowance-certificate" && (
                              <WithholdingAllowanceCertificate
                                goBack={() => this.viewList()}
                                single_doc={true}
                                adminMode={this.state.adminMode}
                                new_doc_id={this.state.doc.id}
                                slug={this.state.doc.slug}
                                lastPage={true}
                                doc={this.state.doc}
                                docs={this.props.docs}
                                {...this.props}
                              />
                            )}
                            {this.state?.doc?.slug === "w-4" && (
                              <ErrorBoundary>
                                <W4
                                  goBack={() => this.viewList()}
                                  single_doc={true}
                                  adminMode={this.state.adminMode}
                                  new_doc_id={this.state.doc.id}
                                  slug={this.state.doc.slug}
                                  lastPage={true}
                                />
                              </ErrorBoundary>
                            )}
                            {this.state?.doc?.slug === "state-tax" && (
                              <ErrorBoundary>
                                <StateTax
                                  goBack={() => this.viewList()}
                                  single_doc={true}
                                  adminMode={this.state.adminMode}
                                  new_doc_id={this.state.doc.id}
                                  slug={this.state.doc.slug}
                                  lastPage={true}
                                  rehire={
                                    this.state.doc?.docs_categories_id === 2 ||
                                    this.state.doc?.docs_categories_id === 5
                                  }
                                  giss={
                                    this.state.doc?.docs_categories_id === 4 ||
                                    this.state.doc?.docs_categories_id === 5
                                  }
                                />
                              </ErrorBoundary>
                            )}
                            {this.state?.doc?.slug ===
                              "equipment-responsibility-form" && (
                              <ErrorBoundary>
                                <EquipmentResponsibilityForm
                                  goBack={() => this.viewList()}
                                  isSingleDoc={true}
                                  adminMode={this.state.adminMode}
                                  docDetails={this.state?.doc}
                                />
                              </ErrorBoundary>
                            )}
                          </div>
                        </section>
                      )}
                    </section>
                  </Tab.Pane>
                  <Tab.Pane eventKey="fourth">
                    <InterviewForm hash={this.props.userHash} listOnly />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Col>
          </Row>
        </Tab.Container>
        
        {/* Delete Document Modal */}
        <ReactModal
          isOpen={this.state.showDeleteModal}
          onClose={this.closeDeleteModal}
          overlayClassName="deletetPopup"
        >
          <div id="deletePopup">
            <div className="modal-head">
              <h4 className="modal-title">Confirm</h4>
              <img
                alt="close"
                className="closeModal"
                onClick={this.closeDeleteModal}
                src={require("../assets/images/close_green.png").default}
              />
            </div>
            <div className="modal-body">
              <div className="status_step step1">
                <label>
                  Are you sure you want to delete this document? This action cannot be undone.
                </label>
                <br />
                <div className="btn_list_popup">
                  <button
                    className="button grey"
                    onClick={this.closeDeleteModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="button"
                    onClick={this.handleDeleteConfirm}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}

UserDocsList.propTypes = {
  userHash: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  docs: PropTypes.object.isRequired,
  chat: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  currentUserPermissions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

function mapStateToProps(state) {
  let { docs, chat, user } = state;
  return {
    docs,
    chat,
    user,
    currentUserPermissions: selectCurrentUserPermissions(state),
  };
}

let connectedUserDocsList = connect(mapStateToProps)(UserDocsList);
export { connectedUserDocsList as UserDocsList };
